import React from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import { useDrawerInvokers } from "@tiny/lib";
import type { RootLoader } from "@/types/RootLoader";
import Tour from "./Tour";
import { masterOnboardingTour, NAVIGATE_AFTER } from "./masterOnboardingTour";

function MasterTour() {
  const navigate = useNavigate();
  const { hideDrawer } = useDrawerInvokers();
  const { userStatus } = useRouteLoaderData("root") as RootLoader;
  const isOnboarded = userStatus.onboardingStep === "FINISHED";

  const handleStepAfter = React.useCallback(
    (stepIndex: number) => {
      if (stepIndex === 4) {
        document
          .querySelector<HTMLElement>("#automations-overview-list-preview")
          ?.click();
      }
      if (stepIndex === 5) {
        hideDrawer();
      }
      const path = NAVIGATE_AFTER[stepIndex];
      if (path) {
        navigate(path);
      }
    },
    [navigate, hideDrawer]
  );

  return (
    <Tour
      tour={masterOnboardingTour}
      enabled={isOnboarded}
      onStepAfter={handleStepAfter}
      helpCenterUrl="https://support.tinyalbert.ai/portal/en/home"
    />
  );
}

export default MasterTour;
